export function Loading() {
  return (
    <div className='fullMessage loading'>
      <h2>Loading ...</h2>
    </div>
  );
}
